module.exports = __webpack_public_path__ + "img/fi.2649533e.svg";